// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment: environmentClass = {
  production: false,
  //keycaptcha: "6Ld_xowUAAAAAHAoubA4SUdCP_KYx7nc5PUFXVcQ", // Clave local
  //keycaptcha: "6Lcy9_0UAAAAAGYhoEZfy4FDVi7rY7YkVOE6rpsf", // Clave pruebas
  keycaptcha: "6Ld1tY0UAAAAABph2-7lYIcfflQ7SmWdMKdHHsdU", //Para ambiente de produción LFP    
  //covid19: "", //Para ambiente local
  //covid19: "/DonacionesColaboradorWeb/", //Para ambiente de pruebas LFP
  covid19: "/DonacionesColaboradorWeb/", //Para ambiente de produción LFP
  redirect: "https://redcooperamoscoomeva.com.co/iniciar-sesion/",
  //backend: "http://" + document.location.hostname + ":8081/donacionescovid-DonacionesCovid/", //Para ambiente local tener en cuenta el puerto LFP
  //backend: "http://localhost:8080/DonacionesColaboradorWeb/", //Para ambiente local
  //backend: "http://eap7-gsisin.pruebas.intracoomeva.com.co/DonacionesColaboradorWeb/", //Para ambiente de pruebas red interna
  backend: "https://secure.coomeva.com.co/DonacionesColaboradorWeb/", //Para ambiente de produción LFP
  blockSubMenu: true //poner true para productivo
};

export class environmentClass {
  production: boolean = false;
  backend: string = "";
  covid19: string;
  redirect: string;
  keycaptcha: string;
  blockSubMenu: boolean;
}



// WEBPACK FOOTER //
// ./src/environments/environment.ts